import { makeStyles } from '@material-ui/core';
import PresetIcon from '@material-ui/icons/LibraryBooks';
import React from 'react';
import {
  Datagrid,
  List,
  ReferenceField,
  Responsive,
  SimpleList,
  TextField,
  TopToolbar,
  Pagination,
  TextInput
} from 'react-admin';
import {
  predictiveSearchFormatter,
  predictiveSearchParser
} from '../../core/utils';
import LinkField from '../../core/components/LinkField';
import Empty from '../../core/components/list/Empty';
import ListTitleBar from '../../core/components/ListTitleBar';
import Filter from '../../core/components/list/StyledFilter';

const useStyles = makeStyles({
  root: {
    marginRight: 'auto'
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();
  return (
    <TopToolbar classes={{ root: classes.root }}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const PresetFilters = props => (
  <Filter variant="standard" {...props}>
    <TextInput
      label="Search by Profile Name"
      source="name"
      alwaysOn
      parse={predictiveSearchParser}
      format={predictiveSearchFormatter}
    />
  </Filter>
);

const PresetTitle = props => {
  return (
    <ListTitleBar
      type="Document Profiles"
      title="New Document Profile"
      createUrl="#/documentpresets/create"
      icon={<PresetIcon />}
      hasCreatePermission={props.hasCreatePermission}
    />
  );
};

const PresetList = props => {
  const {
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    userProfile,
    ...rest
  } = props;

  return (
    <List
      {...rest}
      sort={{ field: 'name', order: 'ASC' }}
      exporter={false}
      title={<PresetTitle hasCreatePermission={hasCreatePermission} />}
      filters={<PresetFilters />}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[20, 25, 30]} />}
      filter={{ subType: 'REPORTING' }}
      bulkActionButtons={false}
      actions={<Actions />}
      empty={<Empty />}
      syncWithLocation
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.name}
            secondaryText={record => record.id}
            tertiaryText={() => ''}
          />
        }
        medium={
          <Datagrid>
            <LinkField
              label="Document Profile Name"
              source="presetName"
              sortBy="name"
            />
            <TextField
              label="Batch Title"
              source="resourceUploadTitle"
              sortable={false}
            />
            <ReferenceField
              label="Document Category"
              source="categoryId"
              reference="categories"
              sortBy="name"
              link=""
              sortable={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Datagrid>
        }
      />
    </List>
  );
};

export default PresetList;
